import React from 'react';
import { createRoot } from 'react-dom/client';
import SplashverseOnboarding from '../routes/splashverse-onboarding';
import '../../css/dist/splashverse-onboarding-loggedout.scss';
import { Provider } from 'react-redux';
import { createReduxStore } from '../stores/splashverse-onboarding/store';

const App = () => {
  return (
    <Provider store={createReduxStore}>
      <SplashverseOnboarding/>
    </Provider>
  )
}

// [AI GENERATED CODE] Updated to React 19 createRoot API
const root = createRoot(document.getElementById("child-onboard"));
root.render(<App/>);
